import capitalizeWord from '../../../utils/capitalizeWord';

const arrayToContainerOptions = (array) => {
  if (!array || !array.length) {
    return [];
  }

  return array.map((item) => {
    const label = capitalizeWord(item);
    return {
      value: item,
      label: label,

      name: label,
      id: item,
    };
  });
};

export default arrayToContainerOptions;
